(() => {
  const main = document.querySelector('main[data-template]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (!main || reducedMotion.matches || !('IntersectionObserver' in window)) return;

  const sectionSelector = ':scope > .shopify-section';
  const cardSelectors = [
    '.product-grid__item',
    '.resource-list__item',
    '[class^="ai-services-categories-grid-"] > [class^="ai-services-category-card-"]',
    '[class^="ai-services-popular-grid-"] > [class^="ai-services-popular-card-"]',
    '[class^="ai-services-steps-grid-"] > *',
    '[class^="ai-who-we-are-grid-"] > [class^="ai-who-we-are-card-"]',
    '[class^="ai-why-choose-us-cards-"] > [class^="ai-why-choose-us-card-"]',
    '[class^="spins-testimonials-grid-"] > [class^="spins-testimonial-card-"]',
    '[id$="__contact_grid"] .section-content-wrapper > *',
    '[id$="__approach"] .section-content-wrapper > :not(:first-child)',
    '[id$="__beliefs"] .section-content-wrapper > :not(:first-child)',
    '[id$="__timeline"] .section-content-wrapper > *',
    '[id$="__included"] .section-content-wrapper > :not(:first-child)',
    '[id$="__guarantees"] .section-content-wrapper > :not(:first-child)',
    '[id$="__questions"] .details'
  ];

  try {
    const sections = [...main.querySelectorAll(sectionSelector)];
    const cards = [...new Set(cardSelectors.flatMap((selector) => [...main.querySelectorAll(selector)]))];
    const revealItems = [...sections, ...cards];

    if (!revealItems.length) return;

    sections.forEach((section) => section.classList.add('spins-scroll-reveal'));

    const cardsByParent = new Map();
    cards.forEach((card) => {
      const siblings = cardsByParent.get(card.parentElement) || [];
      siblings.push(card);
      cardsByParent.set(card.parentElement, siblings);
    });

    cardsByParent.forEach((siblings) => {
      siblings.forEach((card, index) => {
        card.classList.add('spins-scroll-reveal', 'spins-scroll-reveal--card');
        card.style.setProperty('--spins-reveal-delay', `${Math.min(index, 5) * 55}ms`);
      });
    });

    const reveal = (item) => {
      if (!item.classList.contains('spins-scroll-reveal-cleanup')) {
        item.classList.add('spins-scroll-reveal-cleanup');
        const finishReveal = (event) => {
          if (event.target !== item) return;

          item.removeEventListener('transitionend', finishReveal);
          item.classList.remove(
            'spins-scroll-reveal',
            'spins-scroll-reveal--card',
            'spins-scroll-reveal-cleanup',
            'is-visible'
          );
          item.style.removeProperty('--spins-reveal-delay');
        };
        item.addEventListener('transitionend', finishReveal);
      }

      item.classList.add('is-visible');
    };

    const initiallyVisible = revealItems.filter(
      (item) => item.getBoundingClientRect().top < window.innerHeight * 0.88
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          const item = entry.target;
          reveal(item);
          observer.unobserve(item);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    revealItems.forEach((item) => observer.observe(item));
    document.documentElement.classList.add('spins-scroll-effects-ready');
    window.requestAnimationFrame(() => initiallyVisible.forEach(reveal));

    let scrollFrame = 0;
    const updateScrollDepth = () => {
      const depth = Math.min(window.scrollY, 1200);
      main.style.setProperty('--spins-scroll-glow-y', `${(depth * 0.014).toFixed(2)}px`);
      main.style.setProperty('--spins-scroll-grid-y', `${(depth * -0.009).toFixed(2)}px`);
      scrollFrame = 0;
    };

    window.addEventListener(
      'scroll',
      () => {
        if (!scrollFrame) scrollFrame = window.requestAnimationFrame(updateScrollDepth);
      },
      { passive: true }
    );

    updateScrollDepth();
  } catch (error) {
    document.documentElement.classList.remove('spins-scroll-effects-ready');
    main.querySelectorAll('.spins-scroll-reveal').forEach((item) => {
      item.classList.remove(
        'spins-scroll-reveal',
        'spins-scroll-reveal--card',
        'spins-scroll-reveal-cleanup',
        'is-visible'
      );
      item.style.removeProperty('--spins-reveal-delay');
    });
  }
})();
